(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-search-inline"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const searchInput = document.querySelector('input[name="q"]'); // adjust selector
    const predictiveSearch = document.querySelector('.predictive-search');

    if (searchInput && predictiveSearch) {
      searchInput.addEventListener('input', function () {
        if (this.value.length > 2) {
          predictiveSearch.classList.add('loading'); // show spinner
        } else {
          predictiveSearch.classList.remove('loading'); // hide spinner
        }
      });

      // optional: hide spinner once results are loaded
      document.addEventListener('predictiveSearch:complete', function () {
        predictiveSearch.classList.remove('loading');
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
